import moment from 'moment';

export const DEFAULT_START_HOUR = '09:00';
export const DEFAULT_END_HOUR = '22:00';

/**
 * Generate formatted time for hourly filter feature.
 *
 * @param {string} startDate Starting date.
 * @param {string} endDate Ending date.
 * @param {string} startHour Starting hour.
 * @param {string} endHour Ending hour.
 * @param {boolean} allDay Include time format if allDay is false.
 * @returns {Object}
 */

export function getFormattedTime(
  startDate,
  endDate,
  startHour,
  endHour,
  allDay
) {
  const startMoment = moment(startDate);
  const endMoment = moment(endDate);
  const format = 'YYYY-MM-DD HH:mm:ss';

  if (allDay) {
    startMoment.startOf('day');
    endMoment.endOf('day');
  } else {
    const [s1] = startHour.split(':');
    const [e1] = endHour.split(':');
    startMoment.set('hour', s1).startOf('hour');
    endMoment.set('hour', e1).startOf('hour');
  }

  return {
    formattedStart: startMoment.format(format),
    formattedEnd: endMoment.format(format),
  };
}

/**
 * Generate formatted endDate for reporting service request.
 *
 * if hour filter with end time '2019-06-12 23:59:59', return '2019-06-12 23:59:59'.
 * if hour filter with end time '2019-06-12 00:00:00', return '2019-06-11 23:59:59'.
 * if hour filter with end time '2019-06-12 15:00:00', return '2019-06-12 14:59:59'.
 *
 * @param {string} endDate Ending date to be formatted.
 * @returns {string}
 */

export function getFormattedEndDate(endDate) {
  const endMoment = moment(endDate);
  const formatDate = 'YYYY-MM-DD HH:mm:ss';
  const formatTime = 'HH:mm';

  // all day on
  if (endMoment.format(formatTime) === '23:59') {
    return endDate;
  }
  // all day off
  return endMoment.subtract(1, 'seconds').format(formatDate);
}

/**
 * Generate RFC3339 formatted date time. This used for some backend that only accepted
 * RFC3339 as datetime format, ex: Exporting service.
 *
 * if hour filter with end time '2019-06-12 23:59:59', return '2019-06-12T23:59:59'.
 * if hour filter with end time '2019-06-12 00:00:00', return '2019-06-11T00:00:00'.
 * if hour filter with end time '2019-06-12 15:00:00', return '2019-06-12T15:00:00'.
 *
 * @param {string} date date to be formatted.
 * @returns {string}
 */
export function toRfc3339DateTime(date) {
  const format = 'YYYY-MM-DDTHH:mm:ss';
  return moment(date).format(format);
}
